import { oz } from '@weft/utils';
import { invoicesByBillingStatusSchema } from './invoice-by-billing-status-schema';

export const UpdateInvoicesBillingStatusRequestSchema = oz.object({
  invoicesByNewStatus: invoicesByBillingStatusSchema,
}).openapi('UpdateInvoicesBillingStatusRequest');

export type UpdateInvoicesBillingStatusRequestPayload = oz.infer<typeof UpdateInvoicesBillingStatusRequestSchema>;